import { Component, Input, OnInit } from '@angular/core';
import { PerfisServicosModel } from '../model/perfis-servicos.model';
import { RegistroService } from '../services/registro.service';
import { CertificadoService } from '../services/certificado.service';
import DadosCertificadoModel from '../model/dados-certificado.model';
import DadosRegistroModel from '../model/dados-registro.model';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { ModalMensagemComponent } from '../modal-mensagem/modal-mensagem.component';

@Component({
  selector: 'app-lista-servicos',
  templateUrl: './lista-servicos.component.html',
  styleUrls: ['./lista-servicos.component.css']
})
export class ListaServicosComponent implements OnInit {


  @Input() perfil: PerfisServicosModel;
  public dadosCertificado: DadosCertificadoModel;
  public dadosRegistro: DadosRegistroModel;
  public permiteRegistro: boolean

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private certificadoService: CertificadoService,
    private registroService: RegistroService,
  ) { }

  ngOnInit() {
    this.autenticacoesCertificado();
  }

  async autenticacoesCertificado() {

    //grava token da sessao
    await this.obterToken().then(token => {
      //console.log('sessionStorage[\'token\'] = ' + token)
    });
    //obtem certificado
    if (!sessionStorage['dadosCertificado']) {
      await this.certificadoService.obterCertificadoPorToken().then(certificado => {
        this.dadosCertificado = certificado;
        // console.log(dadosCertificado);
      })
        .catch(err => {
          console.error(err);
        });
    } else {
      this.dadosCertificado = JSON.parse(sessionStorage['dadosCertificado']);
    }

    //valida certificado por codigo serial 
    // this.validaCertificadoPorSerial(this.dadosCertificado);


    // Verifica Situacao da Inscricao por codigo serial 
    await this.registroService.consultarSituacaoRegistro(this.dadosCertificado).subscribe(
      data => {
        if (data && data['data']) {
          //this.dadosRegistro = data['items'][0];
          this.setardadosRegistro(data);
          // this.trataSituacao();
          if (this.dadosRegistro !== undefined && (this.dadosRegistro.situacao === 1)) {
            this.mostraDialogMensagem();
          }
        }
        this.atualizaSessaoUsuario();
      }
      , err => {

      }
    );

    //valida certificado
    await this.certificadoService.validaCertificado(this.dadosCertificado).then(isValido => {
      if (!isValido)
        this.permiteRegistro = isValido
    }).catch(err => {
      console.error('erro validaCertificado(): ' + err)
    });

    //Tratamento Token (TKN) Se Token nao permite Renovar
    const orgaoTkn = this.certificadoService.getOrgaoEmissor(this.dadosCertificado).trim()
    if (orgaoTkn === 'Caixa Economica Federal') {
      this.permiteRegistro = false;
      await this.certificadoService.trataMessageToken();
      this.router.navigate(['/acesso-negado']);
    }

    // Verifica Situacao da Inscricao
    //this.consularSituacaoRegistro();

  }


  private async obterToken() {
    //token vazio
    if (!sessionStorage['token'])
      await this.certificadoService.obterToken().then(token => {
        sessionStorage['token'] = token; //grava na sessao..
        return token;
      });
    else
      //token
      return sessionStorage['token'];
  }

  setardadosRegistro(data) {
    this.dadosRegistro = new DadosRegistroModel();
    this.dadosRegistro.bloqueado = data['data']['bloqueado'] === '0' ? false : true;
    this.dadosRegistro.situacao = Number(data['data']['situacao']);
    this.dadosRegistro.nu_certificado = Number(data['data']['nuCertificado']);
    this.dadosRegistro.no_responsavel = data['data']['noResponsavel'];
    this.dadosRegistro.nu_cpf = Number(data['data']['nuCpf']);
    this.dadosRegistro.co_certificado = data['data']['coCertificado'];
    this.dadosRegistro.de_nome_comum = data['data']['deNomeComun'];
    this.dadosRegistro.no_autoridade_certificadora = data['data']['noAutoridadeCertificadora'];
    this.dadosRegistro.nu_perfil = Number(data['data']['nuPerfil']);
    this.dadosRegistro.nu_pis = Number(data['data']['nuPis']);
    this.dadosRegistro.nu_entidade_certificada = Number(data['data']['nuEntidadeCertificada']);
    this.dadosRegistro.de_razao_social = data['data']['deRazaoSocial'];
    this.dadosRegistro.nu_inscricao = data['data']['nuInscricao'];
    this.dadosRegistro.de_perfil = data['data']['dePerfil'];
    this.dadosRegistro.ic_tipo_perfil = Number(data['data']['icTipoPerfil']);
    this.dadosRegistro.ic_tipo_restricao = Number(data['data']['icTipoRestricao']);

  }

  private async trataSituacao() {
    if (this.dadosRegistro.nu_inscricao > '0') {
      //revogação. Pode registrar. direciona para o registro
      if (this.dadosRegistro.situacao === 4 || this.dadosRegistro.situacao === 3) {
        await this.certificadoService.trataRegistroInvalido(this.dadosRegistro.situacao);
        //this.verificaNavegacaoRegistrar();
        this.router.navigate(['/acesso-negado']);
      }
      else {
        if (this.dadosRegistro.situacao > 3) {
          await this.certificadoService.trataRegistroInvalido(this.dadosRegistro.situacao);
          this.router.navigate(['/acesso-negado']);
        }
      }
    } else {
      await this.certificadoService.trataRegistroInvalido(0);
      this.router.navigate(['/acesso-negado']);
    }
  }

  /**
    * Exibe modal com Mensagem.
    */
  mostraDialogMensagem() {
    if (this.dialog.openDialogs.length == 0) {
      const dadosRegistro = this.dadosRegistro;
      this.dialog.open(ModalMensagemComponent, {
        width: '750px',
        data: { dadosRegistro, titulo: 'Mensagem do Sistema' }
      });
    }
  }

  private async atualizaSessaoUsuario() {
    sessionStorage['dadosCertificado'] = JSON.stringify(this.dadosCertificado);
    sessionStorage['dadosRegistro'] = JSON.stringify(this.dadosRegistro);
  }

  private async consularSituacaoRegistro() {

    await this.registroService.consultarSituacaoRegistro(this.dadosCertificado).subscribe(
      data => {
        if (data && data['data']) {
          this.setardadosRegistro(data);
          this.registroService.isInscricaoBloqueada(this.dadosRegistro);
          if (this.dadosRegistro !== undefined && !this.dadosRegistro.bloqueado) {
            if (this.dadosCertificado.caepf) {
              this.trataRegistroCAEPF();
            }
            this.trataSituacao();
          }
        }
        this.atualizaSessaoUsuario();
      }
      , err => {

      }
    );
  }

  private trataRegistroCAEPF() {
    if (this.dadosRegistro)
      this.dadosCertificado.inscricao = this.dadosRegistro.nu_inscricao;
  }
}
